import * as Yup from 'yup'

export const LoginSchema = Yup.object({
    email: Yup.string().required().email().label("Email"),
    password: Yup.string().required().min(8).max(30).label("Password")
});
